import React, { useEffect, useState } from 'react';
import history from 'navigation/history';
import useScript from 'hooks/useScript';

export default function AdsenseBanner({ dataAdSlot, pathname, url }) {
  const [isAdsenseTest, setIsAdsenseTest] = useState(false);

  useEffect(() => {
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) {
      // catch error
    }

    if (window.location.pathname.includes(pathname)) setIsAdsenseTest(true);
    const unlisten = history.listen((location) => setIsAdsenseTest(Boolean(location.pathname.includes(pathname))));
    return unlisten;
  }, []);

  useScript(url, pathname);

  if (!isAdsenseTest && pathname) {
    return null;
  }

  return (
    <ins
      className="adsbygoogle"
      style={{ display: 'block' }}
      data-ad-client="ca-pub-7355366967203449"
      data-ad-slot={dataAdSlot}
      data-ad-format="auto"
      data-full-width-responsive="true"
    />
  );
}
